import { EditRowDecorator } from "@mcleod/components";
import { EditRowDecoratorProps } from "@mcleod/components/src/page/decorators/EditRowDecoratorProps";
import { StringUtil } from "@mcleod/core";
export class FuelSurchargeRowDecorator extends EditRowDecorator implements EditRowDecoratorProps {
    constructor(props?: Partial<EditRowDecoratorProps>) {
        super(props);
        this.themeKey = "editRowDecorator.outerPanel";
    }

    layoutLoaded() {
        if (StringUtil.isEmptyString(this.labelTitle.text))
            this.labelTitle.text = "Add " + this.layout.title;
        if (StringUtil.isEmptyString(this.labelTitle.imageName))
            this.labelTitle.imageName = this.layout.titleImage;
        if (this.layout.paddingBottom == null)
            this.layout.paddingBottom = 24;
    }
}
